import { type LandingPageTestimonial } from '@/app/components/LandingPage/LandingPageTestimonials/types';

const womensHealthTestimonials: LandingPageTestimonial[] = [
  {
    id: 'felicity-v',
    image: {
      alt: 'felicity_v_alt',
      src: 'womens-health-testimonial-1',
    },
    name: 'Felicity V.',
    quote: 'felicity_v_quote',
    tag: 'natural_cycles_oura_article_tag',
  },
  {
    id: 'lindsay',
    image: {
      alt: 'lindsay_alt',
      src: 'womens-health-testimonial-2',
    },
    nameMsgKey: 'lindsay_name',
    quote: 'lindsay_quote',
    tag: 'womens_health_link',
  },
  {
    id: 'maggi',
    image: {
      alt: 'maggi_alt',
      src: 'womens-health-testimonial-3',
    },
    name: 'Maggi',
    quote: 'maggi_quote',
    tag: 'experience_sleep_icon_label',
  },
];

export default womensHealthTestimonials;
